module.exports = __webpack_public_path__ + "static/PressOnSecurity_LogoSmall.f0627fb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/PressOnSecurity_LogoSmall.jpg
// module id = 574
// module chunks = 37581630142331